// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-wrapper-container {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin-top: 50px;
}

.iframe-profile-wrapper-container {
  height: 100%;
  width: 100%;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loader {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100vh;
}

@media (max-width: 767px) {
  .profile-wrapper-container {
    width: 100vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/profile-wrapper/profile-wrapper.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EAGA,UAAA;EAEA,gBAAA;AAFJ;;AAIA;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAIA;EACI,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,aAAA;AADJ;;AAIA;EAGI;IACI,YAAA;EAHN;AACF","sourcesContent":[".profile-wrapper-container{\n    display:flex;\n    flex-direction: column;\n    //align-items: center;\n    //margin-left: 1vw;\n    width:95%;\n    //align-items:stretch;\n    margin-top:50px;\n}\n.iframe-profile-wrapper-container{\n  height:100%;\n  width:100%;\n  min-height:100vh;\n  min-width:100vw;\n  display:flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader {\n    display:flex;\n    align-content: center;\n    justify-content: center;\n    height:100vh;\n}\n\n@media (max-width:767px) {\n\n\n    .profile-wrapper-container {\n        width: 100vw;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
